/* eslint-disable import/first */
import React, { useEffect, useState } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch, shallowEqual } = Redux;
import { FormattedMessage, useIntl } from 'react-intl';
const { selectProductEntities } = Slices.productSlice;
const { selectFirstMenu } = Slices.menuSlice;
const { sendCart, sendLocalCart, cartItems, getUpsellCategory } = Slices.cartSlice;
const {
  selectConfigCountry,
  selectBaseURL,
  getClusterId,
  selectCountryValidations,
} = Slices.configSlice;
const { selectCurrentCountry, selectCartId } = Slices.profileSlice;
const { selectDefaultAddress } = Slices.addressSlice;
import { v4 as uuidv4 } from 'uuid';
import { addToCartGA, trackingAddedToCartGA } from 'spwa-ui-library/esm/utils/helperGA.js';
import css from './index.module.scss';

import UpsellItem from './UpsellItem';
import { Divider } from '@material-ui/core';
import { getProductInfo } from 'spwa-ui-library/esm/redux/store/productSlice';
const UpsellList = (props) => {
  const dispatch = useDispatch();
  // const countries = useSelector(selectConfigCountry);
  // eslint:fix countries is declared but not used.
  const intl = useIntl();
  const clusterId = useSelector(getClusterId);
  const defaultAddress = useSelector(selectDefaultAddress);
  const categories = useSelector((state) => state.category);
  const productsMap = useSelector(selectProductEntities, shallowEqual);
  const menu = useSelector(selectFirstMenu);
  const imgBaseUrl = useSelector(selectBaseURL);
  const cartId = useSelector(selectCartId);
  const country = useSelector(selectCurrentCountry);
  const [pageLoader, setPageLoader] = useState(false);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const currency = countryValidations.currency;
  const profile = useSelector((state) => state.profile);
  const cart = useSelector(cartItems);
  const cartState = useSelector((state) => state.cart);
  const product = useSelector((state) => state.product);

  let currentMenu = useSelector((state) => state.menu);
  currentMenu = Object.values(currentMenu?.entities || {})?.[0];

  const [upsellProducts, setUpsellProducts] = useState([]);

  const [productsArray, setProductsArray] = useState();

  useEffect(() => {
    dispatch(
      getUpsellCategory({
        cluster: currentMenu ? `${currentMenu.menuId}_${currentMenu.menuTemplateId}` : clusterId,
        service: defaultAddress?.addressSubType || 'DELIVERY',
      })
    ).then((resp) => {
      if (resp?.payload?.data?.data?.list) {
        setUpsellProducts(resp.payload.data.data.list);
        setProductsArray(product?.entities);
      } else {
        setUpsellProducts([]);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [count, setCount] = React.useState(0);
  const handleAddCart = (product) => {
    setPageLoader(true);
    let other = [];
    const CustomID = uuidv4();
    if (product.items.length !== 0) {
      product.items.forEach((value, loopId) => {
        other.push(productsMap[value.id || value]);
      });
    }

    var productToAdd = {
      ...product,
      items: other,
      qty: 1,
      UUID: CustomID,
      sellingPrice: product.finalPrice,
    };
    const categorySelected = categories.entities[product?.categories?.[0]];
    console.log(`product - `, product);
    if (!productsMap[product.id]) {
      dispatch(
        getProductInfo({
          id: product.id,
          cluster: clusterId,
          service: defaultAddress?.addressSubType || 'DELIVERY',
          categoryId: product?.categories?.[0],
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then(() => {
        dispatch(
          sendLocalCart({
            productType: productToAdd.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: productToAdd.id,
            data: { ...productToAdd, items: null, category: product?.categories?.[0] },
          })
        );
      });
    } else {
      // debugger;
      dispatch(
        sendLocalCart({
          productType: productToAdd.typeId,
          updatedOn: new Date().getTime(),
          mainProductId: productToAdd.id,
          data: { ...productToAdd, items: null, category: product?.categories?.[0] },
        })
      );
    }

    addToCartGA(product, currency, product?.name, 'ProductUpSellList');
    trackingAddedToCartGA(product, currency, categorySelected?.name);
  };

  return (
    <>
      {upsellProducts?.length <= cart?.length ? null : (
        <div className={css.upsellTitle}>
          <h4>
            <FormattedMessage id="ordedetails_meal" defaultMessage="Complete Your Meal" />
          </h4>
        </div>
      )}
      <div className={css.root}>
        <div className={css.upsellList}>
          {upsellProducts?.length
            ? upsellProducts?.map((item, index) => {
                return (
                  <UpsellItem
                    setCount={setCount}
                    cart={cart}
                    index={index}
                    profile={profile}
                    item={item}
                    menu={menu}
                    handleAddCart={handleAddCart}
                    currency={currency}
                  />
                );
              })
            : ''}
        </div>
      </div>
    </>
  );
};

export default UpsellList;
